import Muuri from 'muuri'

export default class Blog {
  constructor(el) {
    this.el = el
    this.filtersEl = el.closest('.blog').querySelector('.blog--category')
    this.init()
  }

  init() {
    const grid = new Muuri(this.el, {
      items: '.item-blog',
      layoutDuration: 400,
      layoutEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      showDuration: 350,
      showEasing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
      hideDuration: 250,
      hideEasing: 'ease',
      visibleStyles: { opacity: '1', transform: 'scale(1)' },
      hiddenStyles: { opacity: '0', transform: 'scale(0.95)' },
    })

    if (this.filtersEl) {
      this.filtersEl.addEventListener('click', (e) => {
        const li = e.target.closest('li[data-filter]')
        if (!li) return

        const filterValue = li.getAttribute('data-filter') || '*'

        grid.filter((item) => {
          const el = item.getElement()
          if (filterValue === '*') return true
          return el.matches(filterValue)
        })

        this.filtersEl.querySelectorAll('li').forEach(n => n.classList.remove('is-active'))
        li.classList.add('is-active')
      })
    }

    const relayout = () => grid.refreshItems().layout()
    window.addEventListener('load', relayout)
    this.el.querySelectorAll('img').forEach((img) => {
      if (img.complete) return
      img.addEventListener('load', relayout, { once: true })
      img.addEventListener('error', relayout, { once: true })
    })
  }
}
